var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"pa-2",attrs:{"focusable":""}},_vm._l((_vm.translatedFAQ),function(faq,index){return _c('v-expansion-panel',{key:index,staticClass:"mb-2"},[_c('v-expansion-panel-header',[_vm._v(_vm._s(faq.question))]),_c('v-expansion-panel-content',{staticClass:"pt-2"},[_vm._v(_vm._s(faq.answer))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }